import SentimentTrackerCkycContainer from 'containers/SentimentTracker/SentimentTrackerCkyc';
import React from 'react';


function SentimentTrackerCkyc() {
    return ( 
        <>
        <SentimentTrackerCkycContainer />
        </>
     );
}

export default SentimentTrackerCkyc;